module.exports = __webpack_public_path__ + "media/images/front/home_2-cf742837d2171ac94e475721fd685b82.jpg";